import { takeEvery } from 'redux-saga/effects';

import {
  SUBMIT_BID,
  SUBMIT_ASK,
  DELETE_PORTFOLIO_ITEM,
  SET_LAST_CLICKED_PORTFOLIO_ITEM,
  FETCH_PORTFOLIO_ITEM,
  TRACK_PORTFOLIO_ITEM,
} from './actions';
import {
  onPostPortfolioItem,
  onDeletePortfolioItem,
  onSetLastClickedPortfolioItem,
  onFetchPortfolioItem,
  onTrackPortfolioItem,
} from './effects';

export function* fetchPortfolioItemSaga() {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeEvery(FETCH_PORTFOLIO_ITEM, onFetchPortfolioItem);
}

export function* postPortfolioItemSaga() {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeEvery([SUBMIT_BID, SUBMIT_ASK], onPostPortfolioItem);
}

export function* deletePortfolioItemSaga() {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeEvery(DELETE_PORTFOLIO_ITEM, onDeletePortfolioItem);
}

export function* setLastClickedPortfolioItemSaga() {
  yield takeEvery(
    SET_LAST_CLICKED_PORTFOLIO_ITEM,
    onSetLastClickedPortfolioItem,
  );
}

export function* trackPortfolioItemSaga() {
  // @ts-expect-error
  yield takeEvery(TRACK_PORTFOLIO_ITEM, onTrackPortfolioItem);
}
